export type TransmissionType = 'MANUAL' | 'AUTOMATIC';

export interface ExtraService {
  nameHu: string;
  nameEn: string;
  enabled: boolean;
  isCustom: boolean;
}

export const DEFAULT_SERVICES: ExtraService[] = [
  { nameHu: 'Kaució nélküli bérlés', nameEn: 'Rental without deposit', enabled: true, isCustom: false },
  { nameHu: 'MOL Gold Europe üzemanyagkártyával', nameEn: 'With MOL Gold Europe fuel card', enabled: true, isCustom: false },
  { nameHu: 'Telefontükrözés elérhető', nameEn: 'Phone mirroring available', enabled: true, isCustom: false },
  { nameHu: 'Országos autópálya matricával', nameEn: 'With national highway vignette', enabled: true, isCustom: false },
];

export interface Car {
  modelId: string;
  vulogModelid: number | undefined;
  make: string;
  model: string;
  name: string;
  category: string;
  transmission: TransmissionType | undefined;
  numberOfSeats: number | undefined;
  largeLuggageCapacity: number | undefined;
  smallLuggageCapacity: number | undefined;
  extras: ExtraService[];
  imageAssetUrl: string | undefined;
}
